import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { Heading } from '../../components/Heading'
import { Text } from '../../components/Text'
import Header from '../Header'
import ConnectUs from '../../components/ConnectUs'
import FooterSection from '../Footer'
import ServiceCard from '../../components/ServiceCard'
import { services } from '../../assets/dummy'
import bg from '../../assets/img/bg-pattern.png'
import all from '../../assets/img/icon/q-w1.png'
import q2 from '../../assets/img/icon/q-2.png'
import q3 from '../../assets/img/icon/q-3.png'
import q4 from '../../assets/img/icon/q-4.png'
import ServiceModal from '../../components/ServiceCardModal'

const tags = [
  { name: 'Бүх үйлчилгээ', img: all, img2: q2 },
  { name: 'Эсийн банк', img: all, img2: q2 },
  { name: 'Эсийн эмчилгээ', img: all, img2: q3 },
  { name: 'Генетик оношилгоо', img: all, img2: q4 }
]

export default function Services () {
  const [selectedTag, setSelectedTag] = useState('Бүх үйлчилгээ')
  const [selectedService, setSelectedService] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)

  // Filter the services based on the selected tag
  const filteredServices =
    selectedTag === 'Бүх үйлчилгээ'
      ? services
      : services.filter(service => service.tag === selectedTag)

  // Open Modal Function
  const openModal = (service) => {
    setSelectedService(service)
    setIsModalOpen(true)
  }

  // Close Modal Function
  const closeModal = () => {
    setSelectedService(null)
    setIsModalOpen(false)
  }

  return (
    <>
      <Helmet>
        <title>CellClinic - Banking and Therapy</title>
        <meta name='description' content='Cellbank' />
      </Helmet>

      <Header color='blue' gradientColor='white' />

      <div className='maxScreen:max-w-[1440px] extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto rounded-xl p-16'>
        <div
          className='rounded-3xl'
          style={{
            alignSelf: 'stretch',
            background: 'linear-gradient(270deg, #89E5D6 0%, #08393C 100%)'
          }}
        >
          <div
            className='rounded-3xl'
            style={{
              backgroundImage: `url("${bg}")`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              height: '100%',
              padding: 80,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#1B4046'
            }}
          >
            <main className='container mx-auto py-16 px-8 flex flex-row justify-center'>
              <div>
                <Heading size='heading4x1' as='h2' className='text-white'>
                  <p style={{ fontSize: 64, textAlign: 'center' }}>
                    Үйлчилгээнүүд
                  </p>
                </Heading>
                <Text
                  className='text-white'
                  style={{
                    marginTop: 40,
                    fontSize: 22,
                    textAlign: 'center',
                    width: 700
                  }}
                >
                  We are taking the lead in developing innovative treatments
                  through our creative and unique cutting-edge technology
                </Text>
              </div>
            </main>
            <div className='backdrop-blur-xl bg-white/10 border border-white/36 w-full rounded-xl py-10'>
              <div className='flex flex-row justify-center mb-10'>
                {tags.map(item => (
                  <button
                    key={item.name}
                    onClick={() => setSelectedTag(item.name)}
                    className={`backdrop-blur-xl w-fit rounded-lg px-6 py-2.5 ml-5 flex justify-center items-center ${
                      selectedTag === item.name
                        ? 'bg-white text-[#215998]'
                        : 'bg-white/10 text-white'
                    }`}
                  >
                    <img
                      src={selectedTag !== item.name ? item.img : item.img2}
                      alt='Arrow Down'
                      className='h-[16px] w-[16px]'
                      style={{ marginRight: 10 }}
                    />
                    {item.name}
                  </button>
                ))}
              </div>
              <div className='px-10 mobile:px-0 tablet:px-5 maxScreen:max-w-[1440px] extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto extraScreen:px-0 maxScreen:px-0'>
                {/* Pass openModal to ServiceCard */}
                <ServiceCard
                  services={filteredServices}
                  selectedTag={selectedTag}
                  isTag={false}
                  col='grid-cols-4'
                  openModal={openModal} // Pass function
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Component */}
      {isModalOpen && (
        <ServiceModal
          selectedService={selectedService}
          closeModal={closeModal}
        />
      )}

      <div className='maxScreen:max-w-[1440px] extraScreen:max-w-[1660px] maxScreen:mx-auto extraScreen:mx-auto mt-20'>
        <ConnectUs />
      </div>
      <div style={{ marginLeft: 80, marginRight: 80, marginTop: 80 }}>
        <FooterSection />
      </div>
    </>
  )
}
